import {useState} from "react";
import {HiOutlineSparkles} from "react-icons/hi2";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {NavBarItem} from "@/components/navBar/subComponents/NavBarItem/NavBarItem.tsx";
import {WhatsNewModal} from "@/components/whatsnew/WhatsNewModal.tsx";

export const NavBarWhatsNew = () => {
  const {user} = useCurrentUserContext();
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [whatsNew, setWhatsNew] = useState(user!.whatsnew_read_at < user!.whatsnew_updated_at);

  return (
    <>
      <NavBarItem
        as={"button"}
        name={"What's New"}
        // the modal is rendered by this component, so closing the mobile menu would unmount it
        shouldCloseMenu={false}
        onClick={() => {
          setShowWhatsNew(true);
          setWhatsNew(false);
        }}
        icon={HiOutlineSparkles}
        className={whatsNew ? "pulse-color-green-500" : ""}
      />
      <WhatsNewModal
        show={showWhatsNew}
        onCancel={() => {
          setShowWhatsNew(false);
        }}
      />
    </>
  );
};
